export const ink = {
  base: '#0C1229',
  soft: '#4A4F5E',
  mute: '#8A8F9C',
}

export const surface = {
  card: '#ffffff',
  canvas: '#F7F7F9',
  wash: '#FBFBFC',
  linen: '#FBEDE9',
}

export const line = {
  base: 'rgba(12, 18, 41, 0.08)',
  strong: 'rgba(12, 18, 41, 0.16)',
}

export const radius = {
  xs: '4px',
  sm: '8px',
  md: '12px',
  pill: '999px',
  round: '50%',
}

export const shadow = {
  card: '0 1px 2px rgba(12, 18, 41, 0.04)',
  lift: '0 8px 20px -12px rgba(12, 18, 41, 0.18)',
  overlay: '0 24px 60px rgba(12, 18, 41, 0.22)',
}

export const font = {
  caption: '11px',
  small: '12px',
  body: '13px',
  emphasis: '15px',
  heading: '18px',
  title: '22px',
  display: '28px',
  hero: '44px',
}

export const bp = {
  tablet: '1024px',
  mobile: '768px',
}

export const transition = 'all 160ms ease'

export const lowerLabel = (label = '') =>
  String(label)
    .toLowerCase()
    .replace(/building passport/g, 'Building Passport')
    .replace(/unit passport/g, 'Unit Passport')

export const labelStyle = `
  font-size: ${font.caption};
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: ${ink.mute};
`

export const cardStyle = `
  background: ${surface.card};
  border: 1px solid ${line.base};
  border-radius: ${radius.md};
  box-shadow: ${shadow.card};
`
